import { z } from "zod";
import { GENDER_VALUES } from "@typings/entities/individuals";
import type { DefaultValues } from "react-hook-form";
import { ComboBoxDefault } from "@typings/components/comboBox";

export const individualEditSchema = z.object({
  clinicalRecord: z.string().min(1, "Nº ficha clínica é obrigatório"),
  commonName: z.string().min(1, "Nome comum é obrigatório"),
  ufuName: z.string().min(1, "Nome UFU é obrigatório"),
  species: z
    .object({
      label: z.string(),
      value: z.string(),
    })
    .refine(
      (data) => data.value !== "" && data.label !== "",
      "Espécie é obrigatória",
    ),
  gender: z.enum(GENDER_VALUES, {
    error: "Gênero deve ser um valor válido",
  }),
  markingType: z.string().optional(),
  marking: z.string().optional(),
});

export type IndividualEditFormData = z.infer<typeof individualEditSchema>;

export const individualEditDefaultValues: DefaultValues<IndividualEditFormData> =
  {
    clinicalRecord: "",
    commonName: "",
    ufuName: "",
    species: ComboBoxDefault,
    gender: undefined,
    markingType: "",
    marking: "",
  };
